import { forwardRef, type SVGProps } from 'react';

export type PanelRightIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const PanelRightIcon = forwardRef<SVGSVGElement, PanelRightIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 32 32">
    <path
      d="M5.13 3H26.87C27.4349 3 27.9767 3.22441 28.3761 3.62386C28.7756 4.02331 29 4.56509 29 5.13V26.87C29 27.4349 28.7756 27.9767 28.3761 28.3761C27.9767 28.7756 27.4349 29 26.87 29H5.13C4.56509 29 4.02332 28.7756 3.62386 28.3761C3.22441 27.9767 3 27.4349 3 26.87V5.13C3 4.56509 3.22441 4.02331 3.62386 3.62386C4.02332 3.22441 4.56509 3 5.13 3ZM26.62 5.38H20.72V26.62H26.62V5.38ZM5.38 26.62H18.54V5.38H5.38V26.62Z"
      fill="currentColor"
    />
  </svg>
));

PanelRightIcon.displayName = 'PanelRightIcon';
